import Game01 from "./Game01";
/**
 * i18Next NS: `'entries`
 */
export default {
  entries: {
    ...Game01,
  },
};
